import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable, switchMap } from "rxjs";
import { environment } from "src/environments/environment";
import { Configuration } from "../_core/models/configuration.model";
import { ConfigurationService } from "../_core/services/configuration.service";
import { LocalStorageService } from "../_services";
import { ApiService } from "../_services/api/api.service";
import { AppConstant } from "../shared/webdatarocks/app.constant";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  // Endpoints that require anonymous token
  private anonymousEndpoints: string[] = environment.anonymousEndpoints;
  private anonToken: string | null = null;
  baseData: Configuration = new Configuration();

  constructor(
    private _api: ApiService,
    private configurationService: ConfigurationService
  ) {}

  private baseConfig() {
    this.configurationService.getConfiguration().subscribe((res) => {
      this.baseData = res as Configuration;
    });
  }

  // Checks if URL matches any anonymous endpoint by path segment (exact match, case-insensitive)
  private isAnonymousAPI(url: string): boolean {
    const pathSegments = url.split("?")[0].split("/");
    return this.anonymousEndpoints.some((ep) =>
      pathSegments.some((seg) => seg.toLowerCase() === ep.toLowerCase())
    );
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const url = request.url.toLowerCase();

    // avoid infinite loop: don't intercept the anonymous-token request itself
    if (url.includes("/api/Auth/anonymous-token")) {
      return next.handle(request);
    }

    // Check if it's an anonymous endpoint (by path segment match)
    if (this.isAnonymousAPI(request.url)) {
      if (this.anonToken) {
        const cloned = request.clone({
          setHeaders: { Authorization: `Bearer ${this.anonToken}` },
        });
        return next.handle(cloned);
      }

      this.baseConfig();

      if (
        this.baseData.setting?.AnonymousDisigit !== "" &&
        this.baseData.setting?.AnonymousDisigit !== undefined &&
        this.baseData.setting?.AnonymousDisigit !== null
      ) {
        const anonymousHeaders = new HttpHeaders({
          Authorization: `Bearer ${this.baseData.setting?.AnonymousDisigit}`,
        });

        if (anonymousHeaders.get("Authorization") !== null) {
          // Fetch anonymous token, then retry request
          return this._api
            .post2<{ access_token: string }>(
              "Auth/anonymous-token",
              {},
              { headers: anonymousHeaders }
            )
            .pipe(
              map((res) => res.access_token),
              switchMap((token) => {
                this.anonToken = token;
                const cloned = request.clone({
                  setHeaders: {
                    Authorization: `Bearer ${token}`,
                  },
                });
                return next.handle(cloned);
              })
            );
        }
      }
    }

    // Normal authenticated flow (pull login token from your LocalStorageService)
    const token = LocalStorageService.getStorageValue(AppConstant.LoginToken);
    if (token) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    return next.handle(request);
  }
}
